<template>
    <div>
        <v-dialog v-model="dialog" fullscreen :scrim="false" transition="dialog-bottom-transition">
            <v-card tile>
                <v-toolbar>
                    <v-toolbar-title class="text-primary">تقویم</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon="close" @click="dialog = false">
                    </v-btn>
                </v-toolbar>
                <div class="px-sm-8 px-1 pb-5">
                    <persian-calendar
                        :events-list="events"
                        v-model:display-period="period"
                        @addOrEditIsReady="addOrEdit"
                        @delete="deleteEvent"
                        @on-page-add="getCalendarItems"
                        @on-page-subtract="getCalendarItems"
                        ref="calendar"
                    ></persian-calendar>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment-jalaali";
export default {
    data() {
        return {
            dialog: false,
            events: [],
            period: "week",
            receivedYears: []
        }
    },
    methods: {
      async addOrEdit(data, editId){
        const successfulRequest = async () => {
            this.$refs.calendar.$refs.addOrEdit.close();
            await this.getCalendarItems([Math.min(...this.receivedYears), Math.max(...this.receivedYears)]);
            this.$refs.calendar.$refs.showDetails.dialog = false;
            this.$loading.finish();
        }
        this.$loading.start();
        if(editId)
          this.$calendarEventUpdate(editId, data).then(async () => {await successfulRequest()})
        else
          this.$calendarEventStore(data).then(async () => {await successfulRequest()})
      },
      deleteEvent(item){
        this.$confirm(
          `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، گزینه <b>${item.title}</b> حذف خواهد شد.</p>`,
          { buttonTrueText: "حذف", buttonTrueColor: "error" }
        ).then((res) => {
          if (res){
            this.$loading.start();
            this.$calendarEventDelete(item.id).then(async () => {
                await this.getCalendarItems([Math.min(...this.receivedYears), Math.max(...this.receivedYears)]);
                this.$refs.calendar.$refs.showDetails.dialog = false;
                this.$loading.finish();
            })
          }
        });
      },
      async getCalendarItems(currentDate = moment()){
        var start_date = null,
            end_date = null;
        if(Array.isArray(currentDate)) {
            start_date = moment(currentDate[0], 'jYYYY').startOf('jyear').format('X');
            end_date = moment(currentDate[1], 'jYYYY').endOf('jyear').format('X');
        }
        else if(currentDate && !this.receivedYears.includes(currentDate.jYear())){
            this.receivedYears.push(currentDate.jYear())
            start_date = currentDate.startOf('jyear').format('X');
            end_date = currentDate.endOf('jyear').format('X');
        } else
            return true;
        await this.$calendarEventList(start_date && end_date ? {start_date: start_date, end_date: end_date} : '').then(res => {
            let events = [...res.data];
            events.forEach(el => {
                el.start_date = moment(el.start_date);
                if(el.end_date)
                    el.end_date = moment(el.end_date);
                else
                    delete el.end_date
            });
            if(Array.isArray(currentDate))
                return this.events = events;
            this.events.push(...events);
        })
      },
    },
    mounted() {
        this.getCalendarItems();
    },
}
</script>
